// @flow
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CREATE_IBAN_REQUESTED, VALIDATE_IBAN_REQUESTED } from "redux/constants/index";
import {
  DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER,
  DIRECT_DEBIT_IBAN,
} from "Commons/Components/FormComponents/components/PaymentForm/Constants";
import {
  validateAccountBankNumber,
  validateAccountNumber,
  validateIban,
} from "Commons/Utilities/validators/changeService";

export const useIban = (paymentMethod: ?string, accountIban: ?string, accountNumber: ?string, bankCode: ?string) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (paymentMethod === DIRECT_DEBIT_IBAN && accountIban && !validateIban(accountIban)) {
      dispatch({ type: VALIDATE_IBAN_REQUESTED, payload: { iban: accountIban } });
    }
  }, [paymentMethod, accountIban, dispatch]);

  useEffect(() => {
    if (
      paymentMethod === DIRECT_DEBIT_BLZ_ACCOUNT_NUMBER &&
      accountNumber &&
      bankCode &&
      !validateAccountNumber(accountNumber) &&
      !validateAccountBankNumber(bankCode)
    ) {
      dispatch({ type: CREATE_IBAN_REQUESTED, payload: { accountNumber, bankCode } });
    }
  }, [paymentMethod, accountNumber, bankCode, dispatch]);

  const { iban, ibanIsValid, bankCodeIsValid, accountNumberIsValid } = useSelector((state) => state.iban?.iban) || {};
  return [iban, ibanIsValid, bankCodeIsValid, accountNumberIsValid];
};
